require('./brokerStocksPurchaseOrderWizard.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const BrokerStocksPurchaseOrderStep1 = require('./brokerStocksPurchaseOrderStep1/brokerStocksPurchaseOrderStep1');
const BrokerStocksPurchaseOrderStep2 = require('./brokerStocksPurchaseOrderStep2/brokerStocksPurchaseOrderStep2');

class BrokerStocksPurchaseOrderWizard extends React.Component {
    constructor(props) {
        super(props);

        this.handleValidation = this.handleValidation.bind(this);
        this.wizardWillCancel = this.wizardWillCancel.bind(this);
    }

    componentWillReceiveProps(newProps) {
        const { immBrokerStocksPurchaseOrder, immSignaturePattern, onFinish, onSetVisibleStep } = this.props;
        const fetchConfirmOrder = immBrokerStocksPurchaseOrder.get('fetchConfirmOrder');
        const showWarningSMS = immSignaturePattern.get('showWarningSMS');
        const newShowWarningSMS = newProps.immSignaturePattern.get('showWarningSMS');
        const errorState = showWarningSMS !== newShowWarningSMS && newShowWarningSMS;
        const visibleStep = newProps.immBrokerStocksPurchaseOrder.get('visibleStep');
        const visibleStepValid = newProps.immBrokerStocksPurchaseOrder.getIn(['steps', visibleStep - 1, 'valid']);
        const visibleStepLast = visibleStep === newProps.immBrokerStocksPurchaseOrder.get('steps').size;

        if(fetchConfirmOrder !== newProps.immBrokerStocksPurchaseOrder.get('fetchConfirmOrder') || errorState) {
            onFinish();
        } else if (visibleStepValid) {
            if (!visibleStepLast) {
                onSetVisibleStep(visibleStep + 1);
            }
        }
    }

    handleValidation(step) {
        this.props.onValidateStep(step - 1);
    }

    wizardWillCancel() {
        this.props.history.push('/myprofile/broker/corporatesOperations');
    }

    render() {
        const {
            immBrokerStocksPurchaseOrder,
            onChangeAmount,
            onSetVisibleStep,
            onChangeManifest,
            onFinish,
            setDocumentsRead
        } = this.props;
        const visibleStep = immBrokerStocksPurchaseOrder.get('visibleStep');
        const immSteps = immBrokerStocksPurchaseOrder.get('steps');
        const actions = {
            validateStep: this.handleValidation,
            setVisibleStep: onSetVisibleStep,
            setWillCancel: this.wizardWillCancel,
            finish: onFinish
        };

        return (
            <Wizard
                wizardClass="broker-stocks-purchase-order-wizard"
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
            >
                <BrokerStocksPurchaseOrderStep1
                    immBrokerStocksPurchaseOrder={immBrokerStocksPurchaseOrder}
                    actions={actions}
                    onChangeAmount={onChangeAmount}
                />
                <BrokerStocksPurchaseOrderStep2
                    immBrokerStocksPurchaseOrder={immBrokerStocksPurchaseOrder}
                    actions={actions}
                    onChangeManifest={onChangeManifest}
                    setDocumentsRead={setDocumentsRead}
                />
            </Wizard>
        );
    }
}

BrokerStocksPurchaseOrderWizard.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerStocksPurchaseOrder: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    onChangeAmount: PropTypes.func.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onSetVisibleStep: PropTypes.func.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired
};

module.exports = withRouter(BrokerStocksPurchaseOrderWizard);
